import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/pt-br";

export const AppLocationProvider = ({ children }) => (
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
    {children}
  </LocalizationProvider>
);
